import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  forgotPasswordGenerateOtp,
  forgotPasswordVerifyOtp,
} from "../../actions/authActions";
import PlanetCard from "../PlanetCard/PlanetCard";
import OtpInput from "react-otp-input";
import "./VerifyAccount.scss";
import RefreshIcon from "@mui/icons-material/Refresh";
import { toastMessage, zeroPad } from "../../helper";
import { useTranslation } from "react-i18next";
const VerifyAccount = (props: any) => {
  const { t, i18n } = useTranslation();
  const auth = useSelector((state: any) => state.auth);
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(30);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const navigate = useNavigate();

  // const navigateToContacts = () => {
  //   // 👇️ navigate to /contacts
  //   navigate("/verifyaccount");
  // };
  const navigateToSignin = () => {
    // 👇️ navigate to /contacts
    navigate("/auth/login");
  };
  // console.log("seconds outside",seconds);
  useEffect(() => {
    let myInterval = setInterval(() => {
      console.log("seconds", seconds);
      if (seconds > 0) {
        setSeconds((seconds) => seconds - 1);
      }
      if (seconds <= 0) {
        // console.log("seconds 2",seconds);
        clearInterval(myInterval);
        setShowTimer(false);
        setSeconds(30);
      }
    }, 1000);
    return () => {
      // setSeconds(30);
      clearInterval(myInterval);
    };
  });

  const resendOTP = () => {
    setSeconds(30);
    setShowTimer(true);
    setIsLoading(true);
    forgotPasswordGenerateOtp(localStorage.getItem("userName") || "")
      .then(() => {
        setIsLoading(false);
        toastMessage("OTP Resent To Mail", "info");
        // navigate('/resetpassword')
      })
      .catch((err) => {
        setIsLoading(false);
        toastMessage(err.response.data.message, "error");
        console.log(
          "Error:",
          err.response && err.response.data && err.response.data.message
        );
      });
    // resendOTPAction()
    // setRestart(()=> !restart);
  };
  const onChange = async (value: string) => {
    setOtp(value);
    if (value.length === 6) {
      setIsLoading(true);
      forgotPasswordVerifyOtp(auth.username, value)
        .then(() => {
          setIsLoading(false);
          navigate("/resetpassword");
        })
        .catch((err) => {
          setIsLoading(false);
          toastMessage(err.response.data.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        });
      // try{
      //     setIsLoading(true);
      //     const res = await forgotPasswordVerifyOtp(user.username,value);
      //     setIsLoading(false);
      //     if(res){
      //       setError("");
      //         //dispatch(signInUser(user.email,user.password))
      //     }
      // }
      // catch(e) {
      //     setError("Incorrect/Invalid Otp");
      //     console.log(e);
      // }
    }
  };

  return (
    <div className="flex">
      <PlanetCard />
      <div className="flex flex-col w-40v pw-padding-4 pw-height-100v pw-overflow-y-auto">
        <div className="pw-tab-label">{t("Verify Account")}</div>
        <div className="pw-description">{t("OTP sent")}</div>
        <div className="pw-title">{t("Enter OTP")}</div>
        <OtpInput
          value={otp}
          onChange={onChange}
          numInputs={6}
          isInputNum={true}
          className={` ${error ? "pw-error-border" : "pw-border"} w-100v`}
          separator={<span>&nbsp;</span>}
        />

        <div className={`pw-error ` + error ? "" : "pw-display-none"}>
          {error}
        </div>
        <div className="pw-resend-otp-account  flex flex-row">
          <div
            className={`pw-resend-text flex flex-row ${
              !showTimer
                ? "pw-cursor-pointer "
                : "cursor-not-allowed opacity-50"
            }`}
            onClick={!showTimer ? resendOTP : () => {}}
          >
            <div className={` ${showTimer ? "" : "pw-primary-color"}`}>
              <RefreshIcon sx={{ fontSize: "18px" }} />
              <span> {t("Resend OTP")}</span>
            </div>
          </div>

          <div className={` ${showTimer ? "" : "pw-display-none"}`}>
            00:
            {zeroPad(seconds, 2)}
          </div>
        </div>
        <input
          type="button"
          className="pw-light-button pw-width-100"
          value="Back To Sign In"
          onClick={navigateToSignin}
        />
      </div>
    </div>
  );
};

export default VerifyAccount;
